


































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import HumansStoreModule from '../store/HumansStoreModule'

import CoreStoreModule from '@revas/kadra-library/src/revas/vue/vuex/CoreStoreModule'
import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'

import { PageLayout, ContainerLayout, LinearLayout, BaseHeading, BaseTable, BaseButton, BaseIcon, BaseCard, BaseText, BaseDateText, BaseCurrencyText, ClickEvent } from '@revas/reef'

import AppNavigationTabs from '../components/shared/AppNavigationTabs.vue'

import Metadata, { AvailabilityPeriod, Resource } from '../models'

import Page from '../store/models/pagination/Page'

@Component({
  components: {
    PageLayout,
    ContainerLayout,
    LinearLayout,
    BaseHeading,
    BaseTable,
    BaseIcon,
    BaseButton,
    BaseCard,
    BaseText,
    BaseCurrencyText,
    BaseDateText,
    AppNavigationTabs
  }
})
export default class VAvailabilityPeriodCollection extends Vue {
  @Prop() readonly humansStoreModule!: HumansStoreModule
  @Prop() readonly appStoreModule!: AppStoreModule
  @Prop() readonly coreStoreModule!: CoreStoreModule
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly router!: VueRouter
  @Prop() readonly resourceId!: string
  @Prop() readonly routeName!: string

  async created () {
    const firstPage = new Page<AvailabilityPeriod>()
    firstPage.number = 1
    this.listAvailabilityPeriods(firstPage)
  }

  get currentResource (): Resource | null {
    return this.humansStoreModule.currentResource
  }

  get availabilityPeriods (): AvailabilityPeriod[] {
    const a = this.humansStoreModule.currentAvailabilityPeriodsItems
    if (a === null) {
      return []
    } else {
      return a
    }
  }

  //
  //
  // Table Template
  get availabilityPeriodsTableTemplate () {
    return [
      {
        key: 'effectiveFrom',
        label: this.i18n.t('humans.start_date')
      },
      {
        key: 'effectiveTo',
        label: this.i18n.t('humans.end_date')
      },
      {
        key: 'totalCost',
        label: this.i18n.t('humans.total_hourly_cost')
      }
    ]
  }

  onAvailabilityPeriodClick ($event: ClickEvent<AvailabilityPeriod>) {
    if ($event.value) {
      this.goToAvailabilityPeriodEditor($event.value.id)
    }
  }

  //
  //
  // Pagination
  get currentPage (): number {
    return this.humansStoreModule.currentAvailabilityPeriodsPage
  }

  get hasNextPage (): boolean {
    return this.humansStoreModule.currentAvailabilityPeriodsHasNextPage
  }

  onChangePreviousPage () {
    const page = new Page<AvailabilityPeriod>()
    page.number = this.currentPage - 1
    this.listAvailabilityPeriods(page)
  }

  onChangeNextPage () {
    const page = new Page<AvailabilityPeriod>()
    page.number = this.currentPage + 1
    this.listAvailabilityPeriods(page)
  }

  async listAvailabilityPeriods (page: Page<AvailabilityPeriod>) {
    await this.humansStoreModule.asyncListAvailabilityPeriods({ resourceId: this.resourceId, page: page })
  }

  //
  //
  // Metadata
  getMetadataValueByKey (metadata: Metadata[], key: string): string {
    const m = metadata.find((m: Metadata) => m.key === key)
    if (m === undefined) {
      return ''
    }
    return m.value
  }

  //
  //
  // Navigation
  goToCreateAvailabilityPeriod () {
    this.router.push({
      name: 'availability_period',
      params: {
        resourceId: this.resourceId,
        availabilityPeriodId: '-'
      }
    })
  }

  goToAvailabilityPeriodEditor (availabilityPeriodId: string) {
    this.router.push({
      name: 'availability_period',
      params: {
        resourceId: this.resourceId,
        availabilityPeriodId: availabilityPeriodId
      }
    })
  }

  goToResourceEditor () {
    this.router.push({
      name: 'humans.RESOURCE_EDITOR.$NAME',
      params: {
        resourceId: this.resourceId
      }
    })
  }
}
